import React from "react";

function WelcomeBanner() {
  return (
    <div className="relative bg-black p-4 sm:p-6 rounded-sm overflow-hidden mb-8">
      {/* Background illustration */}

      {/* Content */}
      <div className="relative">
        <h1 className="text-2xl md:text-3xl text-white font-bold mb-1">
          SELLING COMMUNITY DASHBOARD
        </h1>
        <p>What's going on the platform:</p>
      </div>
    </div>
  );
}

export default WelcomeBanner;
